import { ChronoUnit } from '@js-joda/core';
import { useUpdateEffect } from 'react-use';

import { AppointmentFormController } from '../AppointmentForm.types';

const ESTIMATED_DURATION_MIN_VALUE = 5;

export const useSyncEndTime = (
   setValue: AppointmentFormController['setValue'],
   watch: AppointmentFormController['watch']
): void => {
   const { date, startTime, estimatedDuration } = watch();
   const startDate = date?.atTime(startTime);
   const remainingMinutesInDay = startDate?.until(date?.plusDays(1).atStartOfDay(), ChronoUnit.MINUTES);

   useUpdateEffect(() => {
      if (estimatedDuration === null) {
         setValue('estimatedDuration', ESTIMATED_DURATION_MIN_VALUE);
         return;
      }

      if (!startTime || remainingMinutesInDay === undefined) {
         return;
      }

      if (remainingMinutesInDay <= estimatedDuration) {
         setValue('estimatedDuration', remainingMinutesInDay);
         setValue('endTime', startTime.plusMinutes(remainingMinutesInDay));
         return;
      }

      setValue('endTime', startTime.plusMinutes(estimatedDuration));
   }, [estimatedDuration]);
};
